/* eslint-disable */
import { defineCustomElement } from "vue";
import template from "./vue-template.hbs";
import "./index.scss";

const BfvMatchday = defineCustomElement({
  props: {
    queryAttributes: String,
    responseAttributes: String,
  },
  data() {
    return {
      queryName: "currentMatchDay",
      subscriptionName: "currentMatchDayUpdate",
      responseData: {
        matches: [],
      },
      errorOccured: false,
      socket: null,
      query: "",
    };
  },
  template,
  methods: {
    // websocket setup
    setupGraphqlSubscription() {
      const websocketProtokoll = location.protocol === "http:" ? "ws" : "wss";

      this.socket = new WebSocket(
        `${websocketProtokoll}://${location.host}/subscriptions`,
        "graphql-ws",
      );
      this.socket.onopen = () => {
        const initPayload = {
          type: "connection_init",
          payload: {},
        };
        this.socket.send(JSON.stringify(initPayload));
      };

      this.socket.onmessage = (response) => {
        const data = JSON.parse(response.data);

        // Check if the ws init is working
        if (data.type === "connection_ack") {
          this.registerSubscription();
        } else if (data.id === "bfv-matchday") {
          this.concactData([data.payload.data.teamAdded]);
        }
      };

      this.socket.onclose = () => {
        // console.log('onclose');
      };
    },

    registerSubscription() {
      if (this.socket.readyState !== 1) {
        return;
      }

      const subscriptionPayload = {
        id: "bfv-matchday",
        payload: {
          query: `subscription {${this.subscriptionName} { ${this.queryAttributes} }}`,
          variables: null,
        },
        type: "start",
      };
      this.socket.send(JSON.stringify(subscriptionPayload));
    },

    concactData(newData) {
      // Implement data concatenation logic if needed
      console.log("New data received:", newData);
    },
  },

  created() {
    // Access GraphQL connector from window
    const graphQLConnector = window.divae?.graphQLConnector;

    if (!graphQLConnector) {
      console.error("GraphQL connector not found");
      this.errorOccured = true;
      return;
    }

    let queryAttributes = "";
    if (this.queryAttributes) {
      queryAttributes = `(${this.queryAttributes})`;
    }

    this.query = `${this.queryName + queryAttributes} { ${this.responseAttributes} }`;

    graphQLConnector.loadData(`{ ${this.query} }`).then((response) => {
      console.log("response", response);

      if (response) {
        this.responseData = response[this.queryName];
      } else {
        console.log("Error loading data");
        this.errorOccured = true;
      }
      //this.setupGraphqlSubscription();
    });
  },

  // Disable shadow DOM to avoid CSS encapsulation issues
  shadowRoot: false,
});

// For dynamic SFC loading
window.bfvSfc = window.bfvSfc || {};
window.bfvSfc["bfv-matchday"] = BfvMatchday;

export default BfvMatchday;

